import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=363f622c"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363f622c')) {
      api.createRecord('363f622c', component.options)
    } else {
      api.reload('363f622c', component.options)
    }
    module.hot.accept("./ContactView.vue?vue&type=template&id=363f622c", function () {
      api.rerender('363f622c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactView.vue"
export default component.exports